import { api } from "./api";
import { loadGuestBiodata, clearGuestBiodata } from "./biodata";

/**
 * Called immediately after register/login/Google-auth.
 * If the user has a guest biodata draft in localStorage, push it into their
 * newly-created primary matrimonial profile so their data isn't lost.
 * Returns true when a draft was imported, so callers can route accordingly.
 */
export async function importGuestDraftIfAny() {
  const draft = loadGuestBiodata();
  if (!draft) return false;
  try {
    // Strip guest-only fields; server anchors user_id + is_primary.
    const {
      user_id: _u,
      id: _i,
      created_at: _c,
      updated_at: _up,
      share_slug: _s,
      is_primary: _p,
      ...safe
    } = draft;
    await api.put("/profile/me", safe);
    clearGuestBiodata();
    return true;
  } catch {
    // Leave the draft in place so the user can retry from the dashboard banner.
    return false;
  }
}
